import {gql} from '@apollo/client';

export const COMPETITOR_FRAGMENT = gql`
  fragment CompetitorParts on Competitors {
    place
    groupNumber
    members {
      clubId
      fullName
      address {
        country
        state
        city
      }
      phoneNumber
    }
    gamesPlayed
    matchesWon
    matchesLose
    matchDifference
    pointsInFavor
    pointsAgainst
    pointDifference
    opponents
    partners
    rounds {
      tableNumber
      competitorOne {
        name
        result
      }
      competitorTwo {
        name
        result
      }
    }
  }
`;

export const CONDITIONS_FRAGMENT = gql`
  fragment ConditionsFields on Requirements {
    gender
    numberOfRounds
    tournamentType
    modalityGame
    pointLimit
  }
`;

export const ADDRESS_FRAGMENT = gql`
  fragment AddressFields on CountryStateCity {
    country
    state
    city
  }
`;

export const USER_FRAGMENT = gql`
  fragment UserCoreFields on User {
    uid
    email
    fullName
    phoneNumber
    gender
    documentType
    document
    clubName
    status
    ranking
  }
`;

export const TOURNAMENT_FRAGMENT = gql`
  ${CONDITIONS_FRAGMENT}
  ${ADDRESS_FRAGMENT}
  fragment TournamentCoreFields on Tournament {
    _id
    name
    startDate
    finishDate
    status
    hasFinal
    standing
    conditions {
      ...ConditionsFields
    }
    address {
      ...AddressFields
    }
  }
`;
